import React from "react";
import { ShimmerDiv, ShimmerTitle } from "./ThemedShimmer";

/**
 * Post details loading placeholder.
 * - text: full-width text post card
 * - media: left media column + right interaction column
 */
const PostDetailSkeleton = ({ variant = "media", className = "" }) => {
  const isText = variant === "text";

  return (
    <div
      className={`post-detail-skeleton row w-100 m-0 ${isText ? "post-detail-skeleton--text" : "post-detail-skeleton--media"} ${className}`.trim()}
      role="status"
      aria-busy="true"
      aria-label="Loading post"
    >
      <span className="skeleton-screen-reader-only">Loading post</span>

      {!isText && (
        <div className="col-md-7 p-0 post-detail-skeleton__media">
          <div className="m-2">
            <ShimmerDiv height={320} width="100%" rounded={8} />
          </div>
        </div>
      )}

      <div className={`${isText ? "col-md-12" : "col-md-5"} p-0 post-detail-skeleton__panel`}>
        <div className="featured-card user-postOnlyContent p-2 m-2 skeleton-surface">
          <div className="d-flex align-items-center p-2">
            <ShimmerDiv height={44} width={44} rounded={50} />
            <div className="ms-2 flex-grow-1">
              <ShimmerTitle line={2} gap={8} />
            </div>
          </div>

          <div className="px-2 pb-2">
            <ShimmerDiv className="mt-2" height={14} width="95%" rounded={4} />
            <ShimmerDiv className="mt-2" height={14} width="88%" rounded={4} />
            <ShimmerDiv className="mt-2" height={14} width="70%" rounded={4} />
            {isText && (
              <>
                <ShimmerDiv className="mt-2" height={14} width="82%" rounded={4} />
                <ShimmerDiv className="mt-2" height={14} width="60%" rounded={4} />
              </>
            )}
          </div>

          <div className="d-flex align-items-center gap-2 px-2 pb-2">
            <ShimmerDiv height={36} width={36} rounded={50} />
            <ShimmerDiv height={36} width="100%" rounded={18} />
          </div>

          <div className="d-flex gap-2 px-2 pb-3">
            <ShimmerDiv height={28} width={64} rounded={6} />
            <ShimmerDiv height={28} width={80} rounded={6} />
            <ShimmerDiv height={28} width={64} rounded={6} />
            <ShimmerDiv height={28} width={56} rounded={6} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostDetailSkeleton;
